module.exports = __webpack_public_path__ + "static/media/pitt-dance.feea7569.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pitt-dance.gif
// module id = 196
// module chunks = 0